import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LightboxModule } from 'ngx-lightbox';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastNotificationsModule } from "ngx-toast-notifications";
import { MatComponentsModule } from '../mat-components.module';
import { ContestGalleryComponent } from './components/contest-gallery/contest-gallery.component';
import { VoteComponent } from './components/vote/vote.component';
import { WinnersGalleryComponent } from './components/winners-gallery/winners-gallery.component';
import { WinnersComponent } from './components/winners/winners.component';
import { ContestService } from './services/contest.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatComponentsModule,
    NgxSpinnerModule,
    ToastNotificationsModule,
    LightboxModule
  ],
  declarations: [
    VoteComponent,
    ContestGalleryComponent,
    WinnersComponent,
    WinnersGalleryComponent
  ],
  exports: [
    VoteComponent,
    ContestGalleryComponent,
    WinnersComponent,
    WinnersGalleryComponent
  ],
  providers: [
    ContestService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class GalleryModule {

}
